import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import classNames from 'classnames'
import { IJobBase } from '../../../types'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
  size?: 'large' | 'small'
}

export const JobItemContentLabel: FC<Props> = ({ job, size = 'small' }) => {
  const { t } = useTranslation('jobs')
  const isLarge = size === 'large'

  return (
    <>
      <div
        className={classNames(styles.typeOfPosition, {
          [styles.large]: isLarge,
        })}
      >
        {t(job?.typeOfPosition)}
      </div>
      {job?.primaryJobCategory && (
        <div
          className={classNames(styles.category, {
            [styles.large]: isLarge,
          })}
        >
          {t(job?.primaryJobCategory.name)}
        </div>
      )}
    </>
  )
}
